import { useAppSelector } from "../../../store/hooks";
import { ganttChartVerticalValues } from "../../../utils/ganttChartValues";

const TaskViolationBox = ({
  xPosition,
  yPosition,
  violationHeight,
  height,
  width,
  shiftEndTime,
  fullTaskViolation,
}: {
  xPosition: number;
  yPosition: number;
  violationHeight: number;
  height: number;
  width: number;
  shiftEndTime: string;
  fullTaskViolation: boolean;
}) => {
  const { pixelPerMinute, timelineRange } = useAppSelector(
    (state) => state.timelineSlice
  );

  const findY = () => {
    return violationHeight >= height
      ? yPosition
      : ganttChartVerticalValues.findTaskYPosition(
          timelineRange!,
          pixelPerMinute,
          shiftEndTime
        );
  };
  return (
    <foreignObject
      className="pointer-events-none"
      x={xPosition + 2}
      y={findY()}
      width={width}
      height={fullTaskViolation ? height : violationHeight}
    >
      <div
        className="h-full pointer-events-none"
        style={{
          borderLeft: "4px solid var(--col-error-3)",
          borderBottom: "1px solid var(--col-error-3)",
          backgroundColor: "var(--col-card-red)",
          borderRadius: fullTaskViolation
            ? "var(--border-radius-xs)"
            : "0 0 var(--border-radius-xs) var(--border-radius-xs)",
        }}
      ></div>
    </foreignObject>
  );
};

export default TaskViolationBox;
